import { getInfrastructureArchitectureDiagramEndpointSelector } from "./getInfrastructureArchitectureDiagramEndpointSelector";
import { RootState } from "@/store/store";
import { infrastructureArchitectureDiagramDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramDataSelector";

export const infrastructureArchitectureDiagramEmptyDataSelector = (
  state: RootState,
) => {
  const response = getInfrastructureArchitectureDiagramEndpointSelector(state);
  const data = infrastructureArchitectureDiagramDataSelector(state);

  return (
    (!response?.isUninitialized &&
      !!data &&
      !response?.isLoading &&
      !Object.keys(data?.complete_architecture?.regions ?? {})?.length) ||
    response?.error
  );
};
